export default __webpack_public_path__ + "static/media/your-watch-icon.b8c10abb.svg";